import { publicApiRequest } from "./publicApi.client";
import type { RescheduleReason } from "./appointment.service";

export interface PublicRescheduleAppointmentSummary {
  appointment_id: string;
  patient_first_name: string;
  doctor_name: string;
  clinic_name: string;
  clinic_phone: string | null;
  current_start_time: string;
  status: string;
}

export interface PublicRescheduleSlot {
  slot_id: string;
  doctor_id: string;
  clinic_id: string;
  start_time: string;
  end_time: string;
  capacity: number;
  booked_count: number;
  is_blocked: boolean;
  created_at: string;
}

export interface PublicRescheduleView {
  appointment: PublicRescheduleAppointmentSummary;
  can_reschedule: boolean;
  reason_code: string | null;
  reschedules_used: number;
  reschedules_max: number;
  available_slots: PublicRescheduleSlot[];
}

export interface PublicRescheduleConfirmResponse {
  new_appointment_id: string;
  new_start_time: string;
}

export const PublicRescheduleAPI = {
  // Token travels as a header, never a URL segment - the backend's request
  // logger records method/path/query on every call, and a path segment would
  // put this live, single-use credential into CloudWatch/API Gateway access
  // logs in plaintext on every use.
  getView: (token: string): Promise<PublicRescheduleView> =>
    publicApiRequest<PublicRescheduleView>(`/public/reschedule`, {
      headers: { "X-Reschedule-Token": token },
    }),

  confirm: (
    token: string,
    new_slot_id: string,
    reason: RescheduleReason,
    reason_note?: string,
  ): Promise<PublicRescheduleConfirmResponse> =>
    publicApiRequest<PublicRescheduleConfirmResponse>(`/public/reschedule`, {
      method: "POST",
      headers: { "X-Reschedule-Token": token },
      body: JSON.stringify({ new_slot_id, reason, reason_note }),
    }),
};
